import React from "react";
// Auto generates routes from files under ./pages
import { useLocation } from "react-router-dom";
import { useRoutes } from "./routesctx";
import { useEffect, useRef, useState } from "react";
import { useDynamicComponent } from "@dynamic";

export function RouterView() {
  const location = useLocation();
  const routes = useRoutes();

  const matchingRoute = routes[location.pathname];
  const [Component] = useDynamicComponent(matchingRoute?.layout);

  return (
    <Component>
      <PageSwitcher></PageSwitcher>
    </Component>
  );
}

function PageSwitcher() {
  const location = useLocation();
  const routes = useRoutes();
  const matchingRoute = routes[location.pathname];
  const [Component] = useDynamicComponent(matchingRoute?.component);
  return <Component></Component>;
}
